import Api from '@/services/Api'

const URL = 'cxc/corte-caja/';
const IMPRIMIR_CORTE = 'imprimir_corte';
const IMPRIMIR_CORTE_GLOBAL = 'imprimir_corte_tienda_global';

export default {

    fetch(_params) {
        return Api().get(URL, {
            params: _params
        })
    },
    getById(id) {
        return Api().get(URL + id)
    },
    save(params) {
        let url = URL;
        if ('id' in params) {
            return Api().put(url + params.id + '/', params)
        }
        return Api().post(url, params)
    },

    imprimir_corte(id) {

        return Api().post(`${URL}${id}/${IMPRIMIR_CORTE}/`);

    },
    imprimir_corte_global(tienda, fecha) {
        return Api().post(`${URL}${IMPRIMIR_CORTE_GLOBAL}/`, { 'tienda': tienda, 'fecha': fecha });
    },
}